export default __webpack_public_path__ + "static/media/punte alberete 2 P.ffc2bb90.mp3";